import * as React from 'react';
import * as S from './styles';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { getOverallRating } from '../../state/actions';
import { IOverallProps } from './types';
import TopTextInput from '../TopTextInput';
import StarsRating from '../StarsRating';
import EditIcon from 'common/icons/editIcon';
import { Context } from '../../context';
import { createRGBA } from '../../state/utils';
import EmptyMessage from '../EmptyMessage';

const OverallWidget: React.FC<IOverallProps> = (props) => {

    const context = React.useContext(Context);

    const dispatch = useDispatch();
    const {
        selectedDealerId,
        overallRating,
    } = useSelector((rootState: RootState) => {
        return {
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
            overallRating: rootState.reviews.overallRating,
        }
    }, shallowEqual);

    React.useEffect(() => {
        if (selectedDealerId) {
            dispatch(getOverallRating(selectedDealerId, props.selectedTab));
        }
    }, [selectedDealerId, props.selectedTab]);

    const handleEditProviders = (e: React.MouseEvent<HTMLDivElement>) => {
        props.handleEditProviders();
    }

    const titleColor = context.editingStatus.titleText?.id === "overallRating" ? context.editingStatus.titleText.color : props.widgetsConfig.overallRating.titleTextColor ?? "#000000";
    const subtitleColor = context.editingStatus.subtitleText?.id === "overallRating" ? context.editingStatus.subtitleText.color : props.widgetsConfig.overallRating.subtitleTextColor ?? "#000000";
    const bodyColor = context.editingStatus.bodyText?.id === "overallRating" ? context.editingStatus.bodyText.color : props.widgetsConfig.overallRating.bodyTextColor ?? "#000000";

    const hasProviders = props.widgetsConfig.overallRating?.providers && props.widgetsConfig.overallRating.providers.length > 0;

    return (
        <S.Root>
            <S.Title>
                <TopTextInput
                    {...props}
                    textTag={props.widgetsConfig.overallRating.titleTag}
                    widgetType={"overallRating"}
                    style={{height: "68px"}}
                    inputStyle={{
                        width: "608px",
                        height: "68px",
                        border: "solid 2px #e7e7ec",
                        borderRadius: "5px",
                        fontWeight: "bold",
                        color: titleColor,
                    }}
                    textStyle={{
                        color: titleColor,
                    }}
                />
            </S.Title>
            {
                React.createElement(
                    props.widgetsConfig.overallRating?.subtitleTag ?? "h3",
                    { style: {
                        ...S.customSubtitle,
                        color: subtitleColor,
                    }}, 
                    "OVERALL CUSTOMER RATING"
                )
            }
            <S.StarsContainer>
                {
                    overallRating &&
                    <StarsRating
                        rating={overallRating.averageStartRating}
                        starColor={context.editingStatus.star?.id === "overallRating" ? createRGBA(context.editingStatus.star.color ?? "#FFD84D", context.editingStatus.star.opacity) : createRGBA(props.widgetsConfig.overallRating.starColor ?? "#FFD84D", props.widgetsConfig.overallRating.starOpacity)}
                    />
                }
                {
                    !hasProviders &&
                    <EmptyMessage
                        message="Add providers to see overall rating"
                        style={{padding: "0px 10px"}}
                    />
                }
                {
                    props.selectedTab === "individual" &&
                    <S.EditIconContainer
                        onClick={handleEditProviders}
                    >
                        <EditIcon />
                    </S.EditIconContainer>
                }
            </S.StarsContainer>
            <S.Reviews style={{
                color: bodyColor,
            }} >
                { 
                    overallRating && hasProviders ?
                        `${overallRating.averageStartRating.toFixed(1)} stars (${overallRating.totalReviews?.toLocaleString('en-US')} Reviews)`
                        : ``
                }
            </S.Reviews>
        </S.Root>
    )
}

export default OverallWidget;
